import React, {ChangeEvent, FC} from "react"
import {AdditionalServiceDto} from "../../types/contracts"
import {useModal} from "../../hooks/useModal";
import {ServiceComponentModal} from "../admin/ServiceComponentModal";
import {CiEdit} from "react-icons/ci";
import {MdOutlineDelete} from "react-icons/md";
import {formatToCzechDate} from "../../utils/functions";

interface ServicesComponentProps {
  services: AdditionalServiceDto[];
  handleServiceChange: (
    index: number,
    e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>
  ) => void;
  handleCheckboxChange: (index: number) => void;
  removeService: (index: number) => void;
  addService: () => void;
  currency?: string;
}

const ServicesComponent: FC<ServicesComponentProps> = ({
                                                         services,
                                                         handleServiceChange,
                                                         handleCheckboxChange,
                                                         removeService,
                                                         addService,
                                                         currency
                                                       }) => {
  const {isOpen, openModal, closeModal} = useModal();

  return (
    <div className="mb-6">
      <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
        Doplňkové služby
        <CiEdit
          onClick={openModal}
          className="text-2xl cursor-pointer text-gray-600 hover:text-gray-800"
        />
      </h3>
      {services.map((service, index) => (
        <div key={index} className="flex justify-between mb-4 bg-gray-100 p-3 rounded-lg">
          <div>
            <p className="flex items-center gap-2">
              Název služby: {service.name}
            </p>
            <p>Popisek: {service.description}</p>
            <p>Cena: {service.amount} {currency}</p>
            {service.forWholeEvent ? <p>Po celou dobu události.</p> :
              <p>Datum: {formatToCzechDate(service.date)}</p>}
              <p>
                  Skrýt ve formuláři (nedostupné):{" "}
                  {services[index]?.isHiddenInRegistration ? "ano" : "ne"}
              </p>
          </div>
          <MdOutlineDelete
            onClick={() => removeService(index)}
            className="text-red-500 rounded-md size-6 cursor-pointer"
          />
        </div>
      ))}
      <ServiceComponentModal
        services={services}
        open={isOpen}
        onClose={closeModal}
        handleServiceChange={handleServiceChange}
        handleCheckboxChange={handleCheckboxChange}
        removeService={removeService}
        addService={addService}
      />
    </div>
  );
};

export default ServicesComponent;
